import React, { useEffect } from "react";
import styles from "./index.module.css";

const PaymentPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.bgColor}>
      <div className="main-container">
        <div className="container-content">
          <div className="card-section">
            <div className="main-card">
              <h1 className={`form-title ${styles.title}`}>Privacy Policy</h1>
              <div className={styles.termsContent}>
                <p>
                  At Study Hub, we are committed to protecting the privacy and
                  security of our customers{"'"} personal information. This Privacy Policy
                  outlines how we collect, use, and safeguard your information when you
                  visit or make a purchase on our website. By using our website, you
                  consent to the practices described in this policy.
                </p>
                <h4>Information We Collect</h4>
                <p>
                  When you visit our website, we may collect certain information about
                  you, including:
                  <ul>
                    <li>
                      Personal identification information (such as your name, email
                      address, and phone number) provided voluntarily by you during the
                      registration or checkout process.
                    </li>
                    <li>
                      Payment and billing information necessary to process your orders,
                      including credit card details, which are securely handled by trusted
                      third-party payment processors.
                    </li>
                    <li>
                      Browsing information, such as your IP address, browser type, and
                      device information, collected automatically using cookies and
                      similar technologies.
                    </li>
                  </ul>
                </p>
                <h4>Use of Information</h4>
                <p>
                  We may use the collected information for the following purposes:
                  <ul>
                    <li>To process and fulfill your orders.</li>
                    <li>
                      To communicate with you regarding your purchases, provide customer
                      support, and respond to inquiries or requests.
                    </li>
                    <li>
                      To personalize your learning experience and present relevant
                      courses, videos recommendations and promotions.
                    </li>
                    <li>
                      To improve our website, and services based on your feedback and
                      browsing patterns.
                    </li>
                    <li>
                      To detect and prevent fraud, unauthorized activities, and abuse of
                      our website.
                    </li>
                  </ul>
                </p>

                <h4>Information Sharing</h4>
                <p>
                  We respect your privacy and do not sell, trade, or otherwise transfer
                  your personal information to third parties without your consent, except
                  in the following circumstances:
                  <ul>
                    <li>
                      Trusted service providers: We may share your information with
                      third-party service providers who assist us in operating our
                      website, processing payments, and delivering services. These
                      providers are contractually obligated to handle your data securely
                      and confidentially.
                    </li>
                    <li>
                      Legal requirements: We may disclose your information if required to
                      do so by law or in response to valid legal requests or orders.
                    </li>
                  </ul>
                </p>
                <h4>Data Security</h4>
                <p>
                  We implement industry-standard security measures to protect your
                  personal information from unauthorized access, alteration, disclosure,
                  or destruction. However, please be aware that no method of transmission
                  over the internet or electronic storage is 100% secure, and we cannot
                  guarantee absolute security.
                </p>
                <h4>Cookies and Tracking Technologies</h4>
                <p>
                  We use cookies and similar technologies to enhance your browsing
                  experience, analyze website traffic, and gather information about your
                  preferences and interactions with our website. You have the option to
                  disable cookies through your browser settings, but this may limit
                  certain features and functionality of our website.
                </p>
                <h4>Changes to the Privacy Policy</h4>
                <p>
                  We reserve the right to update or modify this Privacy Policy at any
                  time. Any changes will be posted on this page with a revised{" "}
                  {`"last
        updated"`}{" "}
                  date. We encourage you to review this Privacy Policy periodically to
                  stay informed about how we collect, use, and protect your information.
                </p>
                <h4>Contact Us</h4>
                <p>
                  If you have any questions, concerns, or requests regarding our Privacy
                  Policy or the handling of your personal information, please contact us
                  using the information provided on our website.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentPolicy;
